import { render, staticRenderFns } from "./yjfx.vue?vue&type=template&id=581abe4f&scoped=true&"
import script from "./yjfx.vue?vue&type=script&lang=js&"
export * from "./yjfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581abe4f",
  null
  
)

export default component.exports